import { IsCreditCard } from 'class-validator';

export class CreditCardGuessTypeModel {
  @IsCreditCard()
  public cardNumber: string;
}
